import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  ZTokenRedemptionOptionSelectResponse,
  ZTokenRedemptionOptionsItem,
} from './models';

const c = initContract();
export const publicTokenContract = c.router(
  {
    getTokenRedemptionOption: {
      method: 'GET',
      path: '/token-redemption-option/:id/',
      pathParams: z.object({
        id: z.coerce.number(),
      }),
      responses: {
        200: ZTokenRedemptionOptionSelectResponse,
        404: z.object({
          message: z.string(),
        }),
      },
    },

    getTokenRedemptionOptions: {
      method: 'GET',
      path: '/token-redemption-options',
      responses: {
        200: ZTokenRedemptionOptionsItem.array(),
      },
    },

    getTokenRedemptionOptionBySlug: {
      method: 'GET',
      path: '/token-redemption-option/slug/:slug',
      pathParams: z.object({
        slug: z.string(),
      }),
      responses: {
        200: ZTokenRedemptionOptionSelectResponse,
        404: z.object({
          message: z.string(),
        }),
      },
    },

    getYouMightAlsoLikeOptions: {
      method: 'GET',
      path: '/you-might-also-like',
      responses: {
        200: ZTokenRedemptionOptionsItem.array(),
      },
    },
  },
  {
    pathPrefix: '/public',
  },
);
